import SearchResult from "./Data";

export default SearchResult;
export * from "./dataRedux";
